module.exports = __webpack_public_path__ + "img/banner.c6b79dab.jpg";